import type { AssessmentTest, DiagnosticReport, EvaluationResult } from '@entities/assessment'

import { Grade } from '@brighterly/lib-core-types/kid/enums'
import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

import { useDisciplineStore } from '@entities/customer'
import { useCustomerStore } from '@entities/customer'

import { configK9 } from '../../config/assessment/grades/grade-k9'
import { configK1, configK1Ela, configK1ElaTest } from '../../config/assessment/grades/grade-k1'
import { configK2, configK2Ela, configK2ElaTest } from '../../config/assessment/grades/grade-k2'
import { configK3, configK3Ela, configK3ElaTest } from '../../config/assessment/grades/grade-k3'
import { configK4, configK4Ela, configK4ElaTest } from '../../config/assessment/grades/grade-k4'
import { configK5, configK5Ela, configK5ElaTest } from '../../config/assessment/grades/grade-k5'
import { configK6, configK6Ela, configK6ElaTest } from '../../config/assessment/grades/grade-k6'
import { configK7, configK7Ela, configK7ElaTest } from '../../config/assessment/grades/grade-k7'
import { configK8, configK8Ela } from '../../config/assessment/grades/grade-k8'
import { configDiagnosticReports } from '../../config/assessment/results/diagnostic-report'
import { configCheckUpElaEvaluationResults, configElaEvaluationResults } from '../../config/assessment/results/evaluation-ela-result'
import { configCheckUpMathEvaluationResults, configMathEvaluationResults } from '../../config/assessment/results/evaluation-math-result'

interface AssessmentTestConfigReturn {
  configs: Record<Grade, Record<Discipline, AssessmentTest>>
  configEvaluationResults: EvaluationResult[]
  configEvaluationCheckUpResults: EvaluationResult[]
  configDiagnosticReports: DiagnosticReport[]
}

export const useAssessmentTestConfig = (): AssessmentTestConfigReturn => {
  const disciplineStore = useDisciplineStore()
  const customersStore = useCustomerStore()
  const code = disciplineStore.getDisciplineCode
  const configs: Record<Grade, Record<Discipline, AssessmentTest>> = {
    [Grade.K]: {
      [Discipline.Math]: configK1,
      [Discipline.ELA]: customersStore.isExp79 ? configK1ElaTest : configK1Ela,
    },
    [Grade.K1]: {
      [Discipline.Math]: configK1,
      [Discipline.ELA]: customersStore.isExp79 ? configK1ElaTest : configK1Ela,
    },
    [Grade.K2]: {
      [Discipline.Math]: configK2,
      [Discipline.ELA]: customersStore.isExp79  ? configK2ElaTest : configK2Ela,
    },
    [Grade.K3]: {
      [Discipline.Math]: configK3,
      [Discipline.ELA]: customersStore.isExp79 ? configK3ElaTest : configK3Ela,
    },
    [Grade.K4]: {
      [Discipline.Math]: configK4,
      [Discipline.ELA]: customersStore.isExp79 ? configK4ElaTest : configK4Ela,
    },
    [Grade.K5]: {
      [Discipline.Math]: configK5,
      [Discipline.ELA]: customersStore.isExp79 ? configK5ElaTest : configK5Ela,
    },
    [Grade.K6]: {
      [Discipline.Math]: configK6,
      [Discipline.ELA]: customersStore.isExp79 ? configK6ElaTest : configK6Ela,
    },
    [Grade.K7]: {
      [Discipline.Math]: configK7,
      [Discipline.ELA]: customersStore.isExp79 ? configK7ElaTest : configK7Ela,
    },
    [Grade.K8]: {
      [Discipline.Math]: configK8,
      [Discipline.ELA]: configK8Ela,
    },
    [Grade.K9]: {
      [Discipline.Math]: configK9,
      [Discipline.ELA]: configK8Ela,
    },
    [Grade.K10]: {
      [Discipline.Math]: configK8,
      [Discipline.ELA]: configK8Ela,
    },
    [Grade.K11]: {
      [Discipline.Math]: configK8,
      [Discipline.ELA]: configK8Ela,
    },
    [Grade.K12]: {
      [Discipline.Math]: configK8,
      [Discipline.ELA]: configK8Ela,
    },
  }

  // TODO: A.H. пропоную робити перевірку і на MATH і на ELA
  const configEvaluationResults = (code === Discipline.ELA) ? configElaEvaluationResults : configMathEvaluationResults
  // TODO: A.H. пропоную робити перевірку і на MATH і на ELA
  const configEvaluationCheckUpResults = (code === Discipline.ELA) ? configCheckUpElaEvaluationResults : configCheckUpMathEvaluationResults

  return {
    configs,
    configEvaluationResults,
    configEvaluationCheckUpResults,
    configDiagnosticReports,
  }
}
